/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CorrectReleaseRequestEditsInner } from './CorrectReleaseRequestEditsInner';
import {
    CorrectReleaseRequestEditsInnerFromJSON,
    CorrectReleaseRequestEditsInnerFromJSONTyped,
    CorrectReleaseRequestEditsInnerToJSON,
} from './CorrectReleaseRequestEditsInner';

/**
 * 
 * @export
 * @interface CorrectReleaseRequest
 */
export interface CorrectReleaseRequest {
    /**
     * OpenSearch document _id for the recording being edited
     * @type {string}
     * @memberof CorrectReleaseRequest
     */
    documentId?: string | null;
    /**
     * earliestParentRelease.id
     * @type {string}
     * @memberof CorrectReleaseRequest
     */
    releaseId: string;
    /**
     * 
     * @type {Array<CorrectReleaseRequestEditsInner>}
     * @memberof CorrectReleaseRequest
     */
    edits: Array<CorrectReleaseRequestEditsInner>;
}

/**
 * Check if a given object implements the CorrectReleaseRequest interface.
 */
export function instanceOfCorrectReleaseRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "releaseId" in value;
    isInstance = isInstance && "edits" in value;

    return isInstance;
}

export function CorrectReleaseRequestFromJSON(json: any): CorrectReleaseRequest {
    return CorrectReleaseRequestFromJSONTyped(json, false);
}

export function CorrectReleaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectReleaseRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentId': !exists(json, 'document_id') ? undefined : json['document_id'],
        'releaseId': json['release_id'],
        'edits': ((json['edits'] as Array<any>).map(CorrectReleaseRequestEditsInnerFromJSON)),
    };
}

export function CorrectReleaseRequestToJSON(value?: CorrectReleaseRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'document_id': value.documentId,
        'release_id': value.releaseId,
        'edits': ((value.edits as Array<any>).map(CorrectReleaseRequestEditsInnerToJSON)),
    };
}

